import * as React from 'react'
import {
  WrapperCaretakerCard,
  ContainerCaretakerCard,
  CaretakerCardContainer,
  CaretakerCardWrapper,
  StyledRightAndTopBlock,
  StyledOverflowText,
  ContainerLeftArrow,
  ClickableAreaLeftArrow,
  LeftArrowIcon,
  ContainerRightArrow,
  ClickableAreaRightArrow,
  RightArrowIcon,
  PointerHoverBlock,
} from '$views/FullMapCaretakers/components/CaretakerCard/CaretakerCard.style'
import { CaretakerLocation } from '$domain/model/caretaker/caretakersLocation/caretakersLocation.model'
import { formatError } from '$views/components/Error/Error.mapper'
import { ErrorView } from '$views/components/Error/Error.model'
import { Error } from '$views/components/Error'
import { Icon } from '$views/components/Icon'
import spinnerIcon from '$icons/Spinner.svg'
import { Block, Text, Button } from '$views/components'
import { Stars } from '$views/components/Stars'
import { getSelectedCaretakersDetails } from '$services/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.service'
import { SelectedCaretakerDetails } from '$domain/model/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.model'
import { breakpoints } from '$utils/theme/breakpoints'
import { sizes } from '$utils/theme/size'
import { localUserIdData } from '$utils/services/saveUserIdDataService/saveUserIdDataService'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { tagManager } from '$infrastructure/tagManager/tagManager'
import { RoundedImage } from '$views/components/RoundedImage'
import { saveRedirectPath } from '$services/session/redirectPath/redirectPath.service'
import { CareType } from '$views/components/CareType'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { ModalBox } from '$views/components/ModalBox'

const leftArrowIcon = require('$icons/leftArrow.svg')
const rightArrowIcon = require('$icons/rightArrow.svg')
const messageIcon = require('$icons/conversationWhite.svg')
const proIcon = require('$icons/pro.svg')
const verifiedIcon = require('$icons/verifiedCheck.svg')
const unverifiedIcon = require('$icons/unverifiedCheck.svg')

interface Props {
  caretakers: CaretakerLocation[]
  onClickCaretaker: (caretaker: CaretakerLocation) => void
}

export const CaretakerCard: React.FC<Props> = ({ caretakers, onClickCaretaker }) => {
  const [isLoading, handleLoading] = React.useState<boolean>(false)
  const [caretakersDetails, setCaretakersDetails] = React.useState<SelectedCaretakerDetails[]>([])
  const [selectedCaretaker, setSelectedCaretaker] = React.useState<SelectedCaretakerDetails>()
  const [errorNotification, setErrorNotification] = React.useState<ErrorView>(undefined)
  const [showErrorNotification, setShowErrorNotification] = React.useState<boolean>(false)
  const [showChatPremiumModal, handleChatPremiumShowModal] = React.useState<boolean>(false)
  const ref = React.useRef(null)
  const scrollReference = React.useRef<any>(null)

  const onClickErrorNotification = () => setShowErrorNotification(false)

  const setErrors = errors => {
    setErrorNotification(errors)
    setShowErrorNotification(true)
  }

  const getRatingAmountCopy = ratingAmount => {
    if (ratingAmount === 1) {
      return '1 opinión'
    }
    return `${ratingAmount} opiniones`
  }

  const capitalizeSpecialty = (specialty: string) => {
    const capitalize = specialty.charAt(0).toUpperCase() + specialty.slice(1)

    return capitalize
  }

  const getSpecialties = caretaker => {
    let textSpecialties = ''
    caretaker.specialties.map((specialty, index) => {
      if (index === 0) {
        textSpecialties += `${capitalizeSpecialty(specialty)}`
      } else {
        textSpecialties += ` · ${capitalizeSpecialty(specialty)}`
      }
    })
    return textSpecialties
  }

  const getSelectedCaretakersId = () => {
    if (caretakers.length > 10) {
      const filteredCaretakers = caretakers.slice(0, 10)
      return filteredCaretakers.map(caretaker => caretaker.caretakerId)
    }

    return caretakers.map(caretaker => caretaker.caretakerId)
  }

  const getCaretakersDetails = async () => {
    handleLoading(true)
    try {
      const selectedCaretakersId = getSelectedCaretakersId()
      const selectedCaretakers = await getSelectedCaretakersDetails(selectedCaretakersId)
      setCaretakersDetails(selectedCaretakers)
      handleLoading(false)
    } catch (error) {
      const caretakerError = formatError(error)
      setErrors(caretakerError)
      handleLoading(false)
    }
  }

  React.useEffect(() => {
    if (caretakers.length > 0) {
      getCaretakersDetails()
    }
  }, [caretakers])

  const redirectToCaretakerProfile = caretaker => {
    const caretakerLocation = caretakers.find(caretake => caretake.caretakerId === caretaker.caretakerId)
    onClickCaretaker(caretakerLocation)
  }

  const isDesktop = () => breakpoints.desktop < window.screen.width

  const getMaxWidthText = () => {
    if (ref.current && isDesktop()) {
      return 200
    }
    if (ref.current && isDesktop()) {
      return 200
    }
    if (ref.current && caretakers.length > 1) {
      return ref.current.offsetWidth * 0.85 - sizes.mini * 5 - 68 - 70 - 10
    }

    if (ref.current) {
      return ref.current.offsetWidth - sizes.mini * 5 - 68 - 70
    }

    return 200
  }

  const onClickNextArrow = () => {
    if (scrollReference.current) {
      const currentElement = scrollReference.current as HTMLDivElement

      currentElement.scrollTo({
        left: currentElement.scrollLeft + 400,
        behavior: 'smooth',
      })
    }
  }

  const onClickPreviousArrow = () => {
    if (scrollReference.current) {
      const currentElement = scrollReference.current as HTMLDivElement

      currentElement.scrollTo({
        left: currentElement.scrollLeft - 400,
        behavior: 'smooth',
      })
    }
  }

  const onClickMessageButton = caretaker => {
    setSelectedCaretaker(caretaker)
    if (localUserIdData.getUserIdData().hasActivePremiumSubscription || isUserAuthenticated()) {
      history.push(routeProvider.chatConversation(caretaker.userId))
      tagManager.push({ event: 'fam', fam_id: 'OpenChat' })
    } else {
      tagManager.push({ event: 'fam', fam_id: 'DriverPremiumAskAvailability' })
      handleChatPremiumShowModal(true)
    }
  }

  const onClickLoginButton = () => {
    saveRedirectPath(routeProvider.caretakerCard(selectedCaretaker.caretakerId))
    history.push(routeProvider.login)
  }

  const showArrows = () => window.screen.width < 400 * caretakers.length + 32 * (caretakers.length + 1)

  const isVerified = caretaker => (process.env.REACT_APP_AUXILIARES as string) !== 'true' || caretaker.isVerified

  return (
    <div ref={ref}>
      {showChatPremiumModal && (
        <ModalBox
          simple
          onAcceptClick={onClickLoginButton}
          title="Inicia sesión o regístrate para chatear"
          buttonLabel="Ok, seguir!"
        >
          Contacta con quien quieras y encuentra a tu profesional ideal.
        </ModalBox>
      )}
      <WrapperCaretakerCard innerRef={scrollReference} fitContent={!showArrows()}>
        {showErrorNotification && <Error error={errorNotification} onClick={onClickErrorNotification} />}
        <ContainerCaretakerCard colums={isLoading ? 1 : caretakersDetails.length}>
          {isLoading ? (
            <CaretakerCardWrapper colums={1}>
              <CaretakerCardContainer>
                <Block flex justify="center">
                  <Icon content={spinnerIcon} size="xl" />
                </Block>
              </CaretakerCardContainer>
            </CaretakerCardWrapper>
          ) : (
            <>
              {caretakersDetails.map((caretaker, key) => (
                <CaretakerCardWrapper key={key} index={key} colums={caretakersDetails.length}>
                  <CaretakerCardContainer>
                    <Block flex>
                      <PointerHoverBlock
                        onClick={() => redirectToCaretakerProfile(caretaker)}
                        data-testid="caretakerImage"
                      >
                        <Block textAlign="center" marginRight="mini">
                          {caretaker.hasActiveProSubscription ? (
                            <RoundedImage
                              bordered
                              borderColor="lightYellow"
                              urlImage={caretaker.caretakerProfileImage}
                              size="smallNormal"
                              bottomIcon={proIcon}
                              bottomIconSize="l"
                              textImage={caretaker.name}
                            />
                          ) : (
                            <RoundedImage
                              bordered
                              urlImage={caretaker.caretakerProfileImage}
                              size="smallNormal"
                              textImage={caretaker.name}
                            />
                          )}
                          {caretaker.averageRating > 0 && (
                            <Block
                              flex
                              justify="center"
                              marginTop={caretaker.hasActiveProSubscription ? 'base' : 'tiny'}
                            >
                              <Stars label={caretaker.averageRating} />
                            </Block>
                          )}
                          {caretaker.ratingAmount > 0 && (
                            <Text tiny>{getRatingAmountCopy(caretaker.ratingAmount)}</Text>
                          )}
                        </Block>
                      </PointerHoverBlock>
                      <Block>
                        <Block flex alignItems="center">
                          <StyledOverflowText subheader capitalize maxWidth={getMaxWidthText()}>
                            {caretaker.name}
                          </StyledOverflowText>
                          {isVerified(caretaker) ? (
                            <Icon content={verifiedIcon} size="m" marginLeft="base" />
                          ) : (
                            <Icon content={unverifiedIcon} size="m" marginLeft="base" />
                          )}
                        </Block>
                        {isVerified(caretaker) && (
                          <StyledOverflowText menu maxWidth={getMaxWidthText()}>
                            {caretaker.qualification}
                          </StyledOverflowText>
                        )}
                        {(process.env.REACT_APP_AUXILIARES as string) === 'true' ? (
                          <Block marginBottom="base">
                            <CareType
                              child={caretaker.careType.child}
                              adult={caretaker.careType.adult}
                              extra={caretaker.careType.extra}
                            />
                          </Block>
                        ) : (
                          <StyledOverflowText menu marginTop="tiny" marginBottom="base" maxWidth={getMaxWidthText()}>
                            {getSpecialties(caretaker)}
                          </StyledOverflowText>
                        )}
                        <Block flex>
                          <Button bordered primary mini onClick={() => redirectToCaretakerProfile(caretaker)}>
                            Perfil
                          </Button>
                          {false && (
                            <Block marginLeft="base">
                              <Button mini primary withIcon onClick={() => onClickMessageButton(caretaker)}>
                                {caretakersDetails.length === 1 ? (
                                  <>
                                    Chat
                                    <Icon
                                      content={messageIcon}
                                      size="m"
                                      marginRight="none"
                                      color="darkGrey"
                                      marginLeft="tiny"
                                    />
                                  </>
                                ) : (
                                  <>Chat</>
                                )}
                              </Button>
                            </Block>
                          )}
                        </Block>
                      </Block>
                      {caretaker.caretakerHourlyRate !== 0 && (
                        <StyledRightAndTopBlock>
                          <Text subheader as="span" weight="medium">
                            {caretaker.caretakerHourlyRate}
                          </Text>
                          <Text as="span" menu>
                            {' '}
                            €/h
                          </Text>
                        </StyledRightAndTopBlock>
                      )}
                    </Block>
                  </CaretakerCardContainer>
                </CaretakerCardWrapper>
              ))}
            </>
          )}
        </ContainerCaretakerCard>
      </WrapperCaretakerCard>
      {showArrows() && (
        <>
          <ContainerLeftArrow onlyDesktop>
            <ClickableAreaLeftArrow onClick={onClickPreviousArrow}>
              <LeftArrowIcon content={leftArrowIcon} size="s" color="darkGrey" marginRight="none" />
            </ClickableAreaLeftArrow>
          </ContainerLeftArrow>
          <ContainerRightArrow onlyDesktop>
            <ClickableAreaRightArrow onClick={onClickNextArrow}>
              <RightArrowIcon content={rightArrowIcon} size="s" color="darkGrey" marginRight="none" />
            </ClickableAreaRightArrow>
          </ContainerRightArrow>
        </>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/CaretakerCard/CaretakerCard.tsx